import React, { useEffect, useState } from 'react';
import { Alert, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useAuth } from '../../providers/AuthProvider';
import { attendanceService, MyAttendance } from '../../services/attendanceService';
import { formatSessionDate, formatSessionTime, StatusChip, SummaryTiles, teacherNames } from './attendanceUi';

// Vue étudiant·e : séances prévues de son groupe TD (et de la promo) et présences au fil de l'eau
const MyAttendanceTab: React.FC = () => {
  const { getValidToken } = useAuth();
  const [data, setData] = useState<MyAttendance | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        const token = await getValidToken();
        if (!token) throw new Error('Session expirée, reconnectez-vous.');
        setData(await attendanceService.getMine(token));
      } catch (e: any) {
        setError(e.message || "Erreur lors du chargement de l'assiduité");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) return <Alert severity="error">{error}</Alert>;
  if (!data) return <CircularProgress />;
  if (data.sessions.length === 0) return <Alert severity="info">Aucune séance n'est encore planifiée.</Alert>;

  return (
    <>
      <SummaryTiles summary={data.summary} />
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>Horaire</TableCell>
              <TableCell>Séance</TableCell>
              <TableCell>Salle</TableCell>
              <TableCell>Encadrant·es</TableCell>
              <TableCell>Statut</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.sessions.map(s => (
              <TableRow key={s.id} sx={{ opacity: s.is_past ? 1 : 0.7 }}>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatSessionDate(s.date)}</TableCell>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatSessionTime(s)}</TableCell>
                <TableCell>{s.session_type}{s.label && s.label !== s.session_type ? ` · ${s.label}` : ''}</TableCell>
                <TableCell>{s.room}</TableCell>
                <TableCell>{teacherNames(s)}</TableCell>
                <TableCell><StatusChip status={s.status} isPast={s.is_past} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default MyAttendanceTab;
